export default __webpack_public_path__ + "static/media/AIChatIconOrange.404db91b.svg";